/// <reference types="./events.d.mts" />
import * as $decode from "../../../../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $editor from "../../../../elements/editors/shared/tiptap/editor.mjs";
import * as $transaction from "../../../../elements/editors/shared/tiptap/transaction.mjs";
import { toList, CustomType as $CustomType } from "../../../../gleam.mjs";

export class BeforeCreate extends $CustomType {}

export class Blur extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class ContentError extends $CustomType {}

export class Create extends $CustomType {}

export class Destroy extends $CustomType {}

export class Drop extends $CustomType {}

export class Focus extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class Paste extends $CustomType {}

export class SelectionUpdate extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class Transaction extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class Update extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class Connected extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export class Updated extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

export const empty = /* @__PURE__ */ toList([
  ["beforecreate", /* @__PURE__ */ new BeforeCreate()],
  ["contenterror", /* @__PURE__ */ new ContentError()],
  ["create", /* @__PURE__ */ new Create()],
  ["destroy", /* @__PURE__ */ new Destroy()],
  ["drop", /* @__PURE__ */ new Drop()],
  ["paste", /* @__PURE__ */ new Paste()],
]);

export const transactions = /* @__PURE__ */ toList([
  ["blur", (var0) => { return new Blur(var0); }],
  ["transaction", (var0) => { return new Transaction(var0); }],
  ["focus", (var0) => { return new Focus(var0); }],
  ["selectionupdate", (var0) => { return new SelectionUpdate(var0); }],
  ["update", (var0) => { return new Update(var0); }],
]);
